<template>
  <div id="app">
    <div v-if="!data.controls.showRightMenu" style="float:right; margin-right: 15px">
      <button type="button" class="btn" v-on:click="data.controls.showRightMenu = true">Show Menu</button>
    </div>
    <div v-if="data.controls.showRightMenu" class="right-menu" style="z-index: 99; position:relative; float:right; margin-right: 15px;">
      <button type="button" class="btn" v-on:click="data.controls.showRightMenu = false">Hide Menu</button>
      <ul class="list-group">
        <li class="list-group-item header">OOT Randomizer Sudoku v1.06</li>
        <li class="list-group-item"><small>Feedback? Tweet <a target="_blank" href="https://twitter.com/aneeslol">*aneeslol</a></small></li>
        <li class="list-group-item"><button type="button" class="btn" v-on:click="data.controls.showSidebar = !data.controls.showSidebar" v-text="data.controls.showSidebar ? 'Hide left content' : 'Show left content'"></button></li>
        <li class="list-group-item"><button type="button" class="btn" v-on:click="saveData">Save Progress</button><br /><small>(Progress also auto-saves)</small></li>
        <li class="list-group-item"><button type="button" class="btn" v-on:click="data.controls.confirmReset = true">Reset Data</button></li>
        <li class="list-group-item">
          Controls:<br />
          Number: <select v-model="data.controls.normalAction" @change="setNormalAction">
              <option value="innerPencil">Set Inner Pencil</option>
              <option value="outerPencil">Set Outer Pencil</option>
              <option value="answer">Set Answer</option>
            </select><br />
          Shift + Number: <select v-model="data.controls.shiftAction" @change="setShiftAction">
              <option value="innerPencil">Set Inner Pencil</option>
              <option value="outerPencil">Set Outer Pencil</option>
              <option value="answer">Set Answer</option>
            </select><br />
          Alt(<i class="icofont-1x icofont-brand-apple" />Ctrl) + Number: <select v-model="data.controls.altAction" @change="setAltAction">
              <option value="innerPencil">Set Inner Pencil</option>
              <option value="outerPencil">Set Outer Pencil</option>
              <option value="answer">Set Answer</option>
            </select>
        </li>
      </ul>
    </div>
    <div v-if="data.controls.confirmReset" class="custom-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Are you sure?</h5>
            <button type="button" v-on:click="data.controls.confirmReset = false" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>This will reset all your progress.</div>
          </div>
          <div class="modal-footer">
            <button type="button" v-on:click="data.controls.confirmReset = false" class="btn btn-secondary">Cancel</button>
            <button type="button" v-on:click="resetData" class="btn btn-primary">Reset</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.controls.showIntro" class="custom-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="width: 800px; font-family:'Arial'; font-size: 12pt; margin-left:-150px">
          <div class="modal-header">
            <h5 class="modal-title">Hello!</h5>
            <button type="button" v-on:click="data.controls.showIntro = false" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="text-align:left">
            <p>Hi, thanks for checking out the puzzle! Some notes and known issues before you begin:</p>
            <p>Updates since the last version: 
              <ul>
                <li>Fixed some bugs with the water temple notes.</li>
              </ul>
            </p>
            <p>If your browser doesn't support local storage or clears it on session end then you won't be able to keep your progress! Looking into possibly adding an import/export data function.</p>
            <p>If your screen's resolution is too low, you can use your browser's zoom functionality, plus there are some options to hide things. 
              Sorry about that! I tried to make things somewhat responsive but it was mostly an afterthought.</p>
            <p>Apparently IE and Edge browsers don't work, also there isn't a way to play on a tablet/phone without a keyboard. Sorry, I don't have any plans to fix these issues at the moment.</p>
            <p>If you have any other feedback or issues, feel free to tweet me <a target="_blank" href="https://twitter.com/aneeslol">@aneeslol</a>!</p>
          </div>
          <div class="modal-footer">
            <button type="button" v-on:click="data.controls.showIntro = false" class="btn btn-secondary">Got it!</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.controls.showVictory" class="custom-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Congratulations!</h5>
            <button type="button" v-on:click="data.controls.showVictory = false" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>You collected all of the medallions!</div>
          </div>
          <div class="modal-footer">
            <button type="button" v-on:click="closeVictory" class="btn btn-secondary">Hooray</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.controls.itemDialog" class="custom-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="icofont-1x icofont-music-alt" />Ba Da Da Daaaa<i class="icofont-1x icofont-music-alt" /></h5>
            <button type="button" v-on:click="data.controls.itemDialog = false" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div style="display: flex; justify-content: center; align-items: center">
              <img v-bind:src="'images/' + data.controls.itemIcon" style="max-width: 40px; max-height: 40px; margin-right: 20px;" />
              <div>{{data.controls.itemMessage}}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" v-on:click="data.controls.itemDialog = false" class="btn btn-secondary">Hooray</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.controls.confirmReset || data.controls.showVictory || data.controls.itemDialog || data.controls.showIntro" class="modal-blackout" />
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="navbar-brand" href="#">Locations:</div>
      <div style="position:relative;">
        <ul class="navbar-nav nav-tabs justify-content-center">
          <li class="nav-item" v-bind:class="getTempleNameByHash() == 'Hyrule' ? 'active' : ''">
            <router-link class="nav-link" v-bind:class="getTempleNameByHash() == 'Hyrule' ? 'active' : ''" to="/">Hyrule Field</router-link>
          </li>
          <li v-if="data.inventory.songs.minuetOfForest.acquired" class="nav-item" v-bind:class="getTempleNameByHash() == 'Forest' ? 'active' : ''">
            <router-link class="nav-link" v-bind:class="getTempleNameByHash() == 'Forest' ? 'active' : ''" to="/forest">Forest Temple</router-link>
          </li>
          <li v-if="data.inventory.songs.nocturneOfShadow.acquired" class="nav-item" v-bind:class="getTempleNameByHash() == 'Shadow' ? 'active' : ''">
            <router-link class="nav-link" v-bind:class="getTempleNameByHash() == 'Shadow' ? 'active' : ''" to="/shadow">Shadow Temple</router-link>
          </li>
          <li v-if="data.inventory.songs.boleroOfFire.acquired" class="nav-item" v-bind:class="getTempleNameByHash() == 'Fire' ? 'active' : ''">
            <router-link class="nav-link" v-bind:class="getTempleNameByHash() == 'Fire' ? 'active' : ''" to="/fire">Fire Temple</router-link>
          </li>
          <li v-if="data.inventory.songs.serenadeOfWater.acquired" class="nav-item" v-bind:class="getTempleNameByHash() == 'Water' ? 'active' : ''">
            <router-link class="nav-link" v-bind:class="getTempleNameByHash() == 'Water' ? 'active' : ''" to="/water">Water Temple</router-link>
          </li>
          <li v-if="data.inventory.songs.requiemOfSpirit.acquired" class="nav-item" v-bind:class="getTempleNameByHash() == 'Spirit' ? 'active' : ''">
            <router-link class="nav-link" v-bind:class="getTempleNameByHash() == 'Spirit' ? 'active' : ''" to="/spirit">Spirit Temple</router-link>
          </li>
        </ul>
        <img class="arrow-left" src="images/arrow-2.png">
        <img class="arrow-right" src="images/arrow.png">
      </div>
    </nav>
    <div class="content">
      <div v-bind:class="data.controls.showSidebar ? 'side-content' : 'side-content-hidden'" style="margin-left: 15px; margin-top:15px; margin-bottom: 15px">
          <div v-if="data.controls.showSidebar">
          <div class="controls card">
            <div class="card-header">
              Controls
            </div>
            <div class="card-body">
              <div>
                <i style="position: absolute; top: 10px; right: 10px; color: #fff6c8" class="icofont-2x icon-button" v-bind:class="data.controls.showBasicControls ? 'icofont-simple-up' : 'icofont-simple-down'" v-on:click="data.controls.showBasicControls = !data.controls.showBasicControls"></i>
                <div v-show="data.controls.showBasicControls">
                  <ul>
                  <li>Click or drag on squares to select them.</li>
                  <li>Shift clicking will add to the selection, Ctrl clicking will remove from the selection.</li>
                  <li>Pressing a digit will set {{data.controls.normalAction == 'outerPencil' ? 'outer pencils' : data.controls.normalAction == 'answer' ? 'the answer' : 'inner pencils'}} on the selected squares.</li>
                  <li>Pressing a digit while holding shift will set {{data.controls.shiftAction == 'outerPencil' ? 'outer pencils' : data.controls.shiftAction == 'answer' ? 'the answer' : 'inner pencils'}}.</li>
                  <li>Pressing a digit while holding alt(or <i class="icofont-1x icofont-brand-apple" />Ctrl) will set {{data.controls.altAction == 'outerPencil' ? 'outer pencils' : data.controls.altAction == 'answer' ? 'the answer' : 'inner pencils'}}.</li>
                  <li>Pressing Delete or Backspace will clear the selected squares.</li>
                  </ul>
                  <hr />
                </div>
              </div>
              <div style="margin-top: 0px; width: 100%">
                <button type="button" class="btn btn-sm btn-outline-secondary" v-bind:disabled="getTempleByHash().historyStep == 0" v-on:click="undo">Undo</button>&nbsp;&nbsp;
                <button type="button" class="btn btn-sm btn-outline-secondary" v-bind:disabled="getTempleByHash().historyStep == getTempleByHash().sudokuHistory.length - 1" v-on:click="redo">Redo</button>&nbsp;&nbsp;
                <button type="button" class="btn btn-sm btn-outline-secondary" v-on:click="saveState">Save State</button>&nbsp;&nbsp;
                <button type="button" class="btn btn-sm btn-outline-secondary" v-on:click="loadState">Load State</button>&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div class="inventory card">
            <div class="card-header">
              Inventory
            </div>
            <div class="card-body">
                <Item v-for="item in data.inventory.items" v-bind:item="item" v-bind:key="item.name" /><br />
                <Item style="margin: 5px 10px" v-for="item in data.inventory.songs" v-bind:item="item" v-bind:key="item.name" /><br />
                <Item v-for="item in data.inventory.medallions" v-bind:item="item" v-bind:key="item.name" /><br />

                <div style="display: flex; justify-content: center; align-items: center; margin-top:10px;">
                  <span v-for="n in data.inventory.hearts" v-bind:key="n">
                    <img style="height: 20px; width: 23px; margin-left: 5px" src="images/heart.png" />
                  </span> 
                  <img v-if="data.inventory.heartPieces > 0" style="height: 20px; width: 23px; margin-left: 5px" v-bind:src="'images/heartPiece' + data.inventory.heartPieces + '.png'" />
                  <img style="width: 11px; height: 18px; margin-left: 10px; margin-right: 5px" src="images/rupee.png" />{{data.inventory.rupees}}
                  <img style="width: 20px; height: 20px; margin-left: 10px; margin-right: 5px" src="images/gold-skulltula.png" />{{data.inventory.goldSkulltulas}}
                </div>
            </div>
          </div>
          <div class="description card" v-if="!getTempleByHash().requiredItem || data.inventory.getItem(getTempleByHash().requiredItem).acquired">
            <div class="card-header">
              Rules
            </div>
            <div class="card-body">
              <div>
                <ul>
                  <li v-for="rule in this.getTempleByHash().rules" v-bind:key="rule" v-html="rule" />
                </ul>
              </div>
              <div v-if="getTempleByHash().hints.length > 0">
                <h6>Hints</h6>
                <div v-if="getTempleByHash().showHint < getTempleByHash().hints.length">
                  Stuck? Click on Navi for a hint:
                  <img src="images/navi.png" style="width: 30px; height: 30px; cursor:pointer" v-on:click="getTempleByHash().showNextHint()" />
                </div>
                <ul>
                  <li v-for="n in getTempleByHash().showHint" v-bind:key="n">{{getTempleByHash().hints[n-1]}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="temple-content" v-if="getTempleByHash().requiredItem && !data.inventory.getItem(getTempleByHash().requiredItem).acquired">
        You don't have the {{data.inventory.getItem(getTempleByHash().requiredItem).name}}!
      </div>
      <div v-if="!getTempleByHash().requiredItem || data.inventory.getItem(getTempleByHash().requiredItem).acquired" class="temple-content">
        <router-view 
          v-bind:inventory="data.inventory" 
          v-bind:controls="data.controls" 
          v-bind:hyruleData="data.hyruleField"
          v-bind:shadowData="data.shadowTemple"
          v-bind:forestData="data.forestTemple"
          v-bind:waterData="data.waterTemple"
          v-bind:spiritData="data.spiritTemple"
          v-bind:fireData="data.fireTemple"
          v-bind:saveData="saveData"
        ></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { buildData } from './presets/data'
import Item from './components/Item.vue'

export default {
  name: 'App',
  components: {
    Item
  },
  data() {
    return {
      data: buildData()
    }
  },
  methods: {
    saveData: function() {
      localStorage.setItem('puzzleData', JSON.stringify(this.$data))
    },
    resetData: function() {
      localStorage.clear();
      this.data = buildData();
      this.data.controls.showIntro = false;
      this.$router.push('/');
    },
    closeVictory: function() {
      this.data.controls.showVictory = false;
      /* eslint-disable no-undef */
      gtag('event', 'finished', {
          'event_category' : 'sudoku',
          'event_label' : 'finished',
          'value': this.data.sessionId
      });
    },
    getTempleByHash: function() {
      switch(window.location.hash) {
        case "#/":
          return this.data.hyruleField;
        case "#/fire":
          return this.data.fireTemple;
        case "#/forest":
          return this.data.forestTemple;
        case "#/shadow":
          return this.data.shadowTemple;
        case "#/spirit":
          return this.data.spiritTemple;
        case "#/water":
          return this.data.waterTemple;
      }
    },
    getTempleNameByHash: function() {
      switch(window.location.hash) {
        case "#/":
          return 'Hyrule';
        case "#/fire":
          return 'Fire'
        case "#/forest":
          return 'Forest'
        case "#/shadow":
          return 'Shadow'
        case "#/spirit":
          return 'Spirit'
        case "#/water":
          return 'Water'
      }
    },
    undo: function() {
        this.getTempleByHash().undo(this.saveData);
    },
    redo: function() {
        this.getTempleByHash().redo(this.saveData);
    },
    saveState: function() {
        this.getTempleByHash().setSaveState(this.saveData);
    },
    loadState: function() {
        this.getTempleByHash().restoreSaveState(this.saveData);
    },
    setShiftAction: function(event) {
      var value = event.target.value;
      if(this.data.controls.normalAction == value) {
        if(this.data.controls.altAction == 'outerPencil') {
          this.data.controls.normalAction = value == 'innerPencil' ? 'answer' : 'innerPencil';
        } else if(this.data.controls.altAction == 'answer') {
          this.data.controls.normalAction = value == 'outerPencil' ? 'innerPencil' : 'outerPencil';
        } else if(this.data.controls.altAction == 'innerPencil') {
          this.data.controls.normalAction = value == 'outerPencil' ? 'answer' : 'outerPencil';
        }
      }
      else if(this.data.controls.altAction == value) {
        if(this.data.controls.normalAction == 'outerPencil') {
          this.data.controls.altAction = value == 'innerPencil' ? 'answer' : 'innerPencil';
        } else if(this.data.controls.normalAction == 'answer') {
          this.data.controls.altAction = value == 'outerPencil' ? 'innerPencil' : 'outerPencil';
        } else if(this.data.controls.normalAction == 'innerPencil') {
          this.data.controls.altAction = value == 'outerPencil' ? 'answer' : 'outerPencil';
        }
      }
    },
    setNormalAction: function(event) {
      var value = event.target.value;
      if(this.data.controls.shiftAction == value) {
        if(this.data.controls.altAction == 'outerPencil') {
          this.data.controls.shiftAction = value == 'innerPencil' ? 'answer' : 'innerPencil';
        } else if(this.data.controls.altAction == 'answer') {
          this.data.controls.shiftAction = value == 'outerPencil' ? 'innerPencil' : 'outerPencil';
        } else if(this.data.controls.altAction == 'innerPencil') {
          this.data.controls.shiftAction = value == 'outerPencil' ? 'answer' : 'outerPencil';
        }
      }
      else if(this.data.controls.altAction == value) {
        if(this.data.controls.shiftAction == 'outerPencil') {
          this.data.controls.altAction = value == 'innerPencil' ? 'answer' : 'innerPencil';
        } else if(this.data.controls.shiftAction == 'answer') {
          this.data.controls.altAction = value == 'outerPencil' ? 'innerPencil' : 'outerPencil';
        } else if(this.data.controls.shiftAction == 'innerPencil') {
          this.data.controls.altAction = value == 'outerPencil' ? 'answer' : 'outerPencil';
        }
      }
    },
    setAltAction: function(event) {
      var value = event.target.value;
      if(this.data.controls.normalAction == value) {
        if(this.data.controls.shiftAction == 'outerPencil') {
          this.data.controls.normalAction = value == 'innerPencil' ? 'answer' : 'answer';
        } else if(this.data.controls.shiftAction == 'answer') {
          this.data.controls.normalAction = value == 'outerPencil' ? 'innerPencil' : 'outerPencil';
        } else if(this.data.controls.shiftAction == 'innerPencil') {
          this.data.controls.normalAction = value == 'outerPencil' ? 'answer' : 'outerPencil';
        }
      }
      else if(this.data.controls.shiftAction == value) {
        if(this.data.controls.normalAction == 'outerPencil') {
          this.data.controls.shiftAction = value == 'innerPencil' ? 'answer' : 'answer';
        } else if(this.data.controls.normalAction == 'answer') {
          this.data.controls.shiftAction = value == 'outerPencil' ? 'innerPencil' : 'outerPencil';
        } else if(this.data.controls.normalAction == 'innerPencil') {
          this.data.controls.shiftAction = value == 'outerPencil' ? 'answer' : 'outerPencil';
        }
      }
    }
  }
}
</script>

<style>
@font-face {
  font-family:'Hyrule';
  src: url('assets/fonts/The Wild Breath of Zelda.otf')
}
@font-face {
  font-family:'Triforce';
  src: url('assets/fonts/Triforce.ttf')
}
@media all and (max-width: 1670px) {
  h3 {
    font-size: 24px;
  }
  ul {
    padding-left: 10px;
  }
}
@media all and (min-width: 1671px) {
  h3 {
    font-size: 36px;
  }
}
html {
  height: 100%;
}
body {
  margin-top: 75px;
  background-image: url('assets/images/background.png'), url('assets/images/background-2.png');
  background-repeat: repeat-x;
  background-position: top, bottom;
  background-attachment: fixed;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}
.custom-modal {
  position: absolute;
  width: 500px;
  left: 50%;
  top: 40%;
  z-index: 999999;
  transform: translate(-50%, -50%);
}
.modal-blackout {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999998;
  background-color: rgba(0, 0, 0, .5);
}
.card {
  margin-top: 15px;
  background-image: url("assets/images/paper.png");
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 4px 8px 0 rgba(0, 0, 0, 0.19);
}
.card-body {
  background-image: url("assets/images/crest.png");
  background-position:center;
  background-repeat: no-repeat;
  background-size: contain;
}
.right-menu, .modal-dialog {
  font-family: 'Triforce';
  font-size: 25px;
  letter-spacing: 1px;
  color: gray;
}
.right-menu .header, .modal-header {
  font-family: 'Hyrule';
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-size: 25px;
  color: #fff6c8;
  background-image:url("assets/images/rockywall.png") !important;
}
.right-menu .list-group-item, .modal-content {
  background-image: url("assets/images/paper.png");
}
.right-menu button, .modal-footer button {
  background: none;
  border: none;
  padding: 0px 10px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 4px 8px 0 rgba(0, 0, 0, 0.19);
  color: gray;
}
h3 {
  font-family: 'Hyrule';
  letter-spacing: 1px;
  text-transform: uppercase;
}
.navbar-brand {
  margin-left: 30px;
  font-family: 'Hyrule';
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 30px;
}
.arrow-left {
  position: absolute;
  bottom: -4px;
  left: -20px;
}
.arrow-right {
  position: absolute;
  bottom: -4px;
  right: -20px;
}
.nav-tabs {
  border-bottom: 10px ridge rgb(80, 80, 80);
}
.navbar-nav.nav-tabs {
  padding: 0px 5px;
}
.nav-link {
  font-family: 'Hyrule';
  text-transform: lowercase;
  font-size: 25px;
  background-image:url("assets/images/paper.png");
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-bottom: 0px;
  border: none !important;
}
button.btn {
  font-family: 'Triforce';
  text-transform: lowercase;
  font-size: 25px;
  letter-spacing: 1px;
  box-shadow: 4px 0px 8px 0 rgba(0, 0, 0, 0.2), -4px 0px 8px 0 rgba(0, 0, 0, 0.19);
  background-image:url("assets/images/paper.png");
  border: none;
  margin: 3px;
}
button.btn:disabled {
  box-shadow: none;
}
.nav-item.active {
  box-shadow: 4px 0px 8px 0 rgba(0, 0, 0, 0.2), -4px 0px 8px 0 rgba(0, 0, 0, 0.19);
  z-index: 999;
}
.card-header {
  font-family: 'Hyrule';
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-size: 25px;
  color: #fff6c8;
  background-image:url("assets/images/rockywall.png");
  padding: 5px;
}
.card ul {
  text-align: left;
}
.icon-button {
  cursor: pointer;
}
.card-body {
  font-size: 9pt;
}
.side-content {
  width: 20%;
  min-width: 440px;
}
.side-content-hidden {
  position: absolute;
}
.temple table {
  background-image:url("assets/images/paper.png");
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 4px 8px 0 rgba(0, 0, 0, 0.19);
}
.temple-content {
  width: 80%;
}
.content {
  margin-top: 20px;
  display: flex;
}
.tooltipIcon {
  width: 20px;
  height: 20px;
  margin-top: -5px;
}
.notes {
  margin-top: 15px;
  width: 585px;
}
select {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 12pt;
}
</style>
